import {useApolloClient} from '@apollo/client';

import {isInaccessibleInfo} from 'auth/RequestAccess';
import {isMolstarPreviewFile} from 'files/preview/FilePreviewConstants';
import {GetScratchFile, GetScratchFileVariables} from 'pipelines/files/network/__generated/GetScratchFile';
import {GET_SCRATCH_FILE_QUERY} from 'pipelines/files/network/GetScratchFile';
import {ScratchFileContent} from 'pipelines/files/ScratchFileTypes';

/** Whether a table cell shows the file as a chip rather than a fixed-size inline preview. */
export function scratchFileRendersAsChip(scratchFile: ScratchFileContent): boolean {
  return isMolstarPreviewFile(scratchFile.mimeType, scratchFile.filename);
}

/**
 * Counts how many of the files will render as a fixed-size inline preview, using only cached metadata so that
 * off-screen cells can reserve space without fetching. Returns null if any file's metadata isn't cached yet.
 */
export default function useCachedInlinePreviewCount(fileIds: ReadonlyArray<string>): number | null {
  const client = useApolloClient();
  let count = 0;
  for (const fileId of fileIds) {
    const scratchFile = client.readQuery<GetScratchFile, GetScratchFileVariables>({
      query: GET_SCRATCH_FILE_QUERY,
      variables: {id: fileId},
    })?.scratchFile;
    if (scratchFile == null) {
      return null;
    }
    if (!isInaccessibleInfo(scratchFile) && !scratchFileRendersAsChip(scratchFile)) {
      count++;
    }
  }
  return count;
}
